<template>
  <lm-modal
    :ref="modalName"
    :name="modalName"
    :type="modalType"
    class="ModalEditorHelp"
    title="Editor Reference Help"
    full-height
    remove-footer
    @[Events.AFTER_OPEN]="modalOpened"
  >
    <editor-help-title title="General tips" />
    <ul class="TipsList">
      <li>
        You can format your messages using the formatting toolbar or keyboard
        shortcuts
      </li>
      <li>
        You can drag and drop images from your computer or your browser directly
        into the Editor
      </li>
      <li>
        Drag both text and images to rearrange your messages
      </li>
      <li>Press <shortcut text="Shift+Enter" />to insert a line break</li>
      <li>Press <shortcut text="Cmd/Ctrl+Enter" />to submit the form</li>
    </ul>
    <editor-help-title title="Format Reference" class="mb-4" />
    <div class="mb-8">
      <h1 class="mb-2 pb-1 text-l text-gray-900">Text Style</h1>
      <p class="mb-2">Allows you to use normal text or headings.</p>
      <ul class="TipsList">
        <li>Heading 1: <shortcut text="Shift+Ctrl+1" /></li>
        <li>Heading 2: <shortcut text="Shift+Ctrl+2" /></li>
      </ul>
    </div>
    <help-block title="Bold" icon="bold" shortcut="B" />
    <help-block title="Italic" icon="italic" shortcut="I" />
    <help-block title="Strikethrough" icon="strikethrough" shortcut="D" />
    <help-block
      title="Bullet list"
      icon="listBulleted"
      :select-text="false"
      unique-shortcut="Ctrl+Shift+8"
    />
    <help-block
      title="Number list"
      icon="listNumbered"
      :select-text="false"
      unique-shortcut="Ctrl+Shift+9"
    />
    <help-block
      title="Quote"
      icon="quote"
      :select-text="false"
      unique-shortcut="Cmd/Ctrl+>"
    />
    <help-block title="Code" icon="code" shortcut="`" />
    <help-block
      title="Code Block"
      icon="codeblock"
      :select-text="false"
      unique-shortcut="Ctrl+Shift+\"
    >
      Press <shortcut text="Shift+Enter" /> to exit.
    </help-block>
    <help-block title="Link" icon="link" shortcut="K" />
    <help-block
      title="Image"
      icon="photo"
      :select-text="false"
      extra="Or drag and drop images from your computer or your browser"
    >
      Images and GIFs supported.
    </help-block>
    <help-block title="Media" icon="movie" :select-text="false">
      YouTube, Vimeo and SlideShare supported.
    </help-block>
    <help-block title="Undo" icon="undo" shortcut="Z" />
    <help-block title="Redo" icon="redo" shortcut="Shift+Z" />
  </lm-modal>
</template>

<script>
import EditorHelpTitle from '@/components/modals/editorHelp/EditorHelpTitle'
import HelpBlock from '@/components/modals/editorHelp/HelpBlock'
import Shortcut from '@/components/modals/editorHelp/Shortcut'
import {Events, Modal, ModalType} from '@/lib/definitions'
import LmModal from '@/components/ui/LmModal'

export default {
  name: 'ModalEditorHelp',
  components: {
    Shortcut,
    EditorHelpTitle,
    HelpBlock,
    LmModal
  },
  data() {
    return {
      Events,
      modalName: Modal.EDITOR_HELP,
      modalType: ModalType.SUBMODAL,
      modalRef: null
    }
  },
  computed: {},
  mounted() {
    this.modalRef = this.$refs[this.modalName]
  },
  created() {},
  methods: {
    modalOpened() {}
  }
}
</script>

<style scoped>
.TipsList {
  @apply mb-10 pl-5 list-disc leading-normal;
}
.TipsList li {
  margin-bottom: 6px;
}
</style>
